// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"5897f239","212":"4af02abf","388":"d5d5919a","396":"2baa1643","421":"25b1d5ea","655":"d3e4275c"}[chunkId] + ".chunk.css";
};